const API = '/api/pagos_historial';

export const getPagos = async (clienteServiciosId = null) => {
  const url = clienteServiciosId ? `${API}?cliente_servicios_id=${clienteServiciosId}` : API;
  const res = await fetch(url);
  if (!res.ok) {
    const errorData = await res.json().catch(() => ({}));
    throw new Error(errorData.error || 'Error al obtener historial de pagos');
  }
  return await res.json();
};

export const registrarPago = async (pagoData) => {
  const res = await fetch(API, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(pagoData)
  });
  if (!res.ok) {
    const errorData = await res.json().catch(() => ({}));
    throw new Error(errorData.error || 'Error al registrar pago');
  }
  return await res.json();
};

export const eliminarPago = async (id) => {
  const res = await fetch(`${API}?id=${id}`, {
    method: 'DELETE'
  });
  if (!res.ok) {
    const errorData = await res.json().catch(() => ({}));
    throw new Error(errorData.error || 'Error al eliminar pago');
  }
  return await res.json();
};
